export function menu() {
    document.querySelectorAll('.sidebar-menu > .menu-item-has-children > a').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            const subMenu = link.parentElement.querySelector('.sub-menu');

            if (!subMenu) {
                return;
            }

            link.parentElement.classList.toggle('active');
            subMenu.classList.toggle('active');
        });
    });
}
